import React from 'react';
import { CalendarDaysIcon, LeafIcon, FlowerIcon, BookOpenIcon, BriefcaseIcon } from 'lucide-react';
import { kitContents } from '../data/kit';
const icons = {
  calendar: CalendarDaysIcon,
  leaf: LeafIcon,
  flower: FlowerIcon,
  book: BookOpenIcon,
  briefcase: BriefcaseIcon
};
export function KitContentsSection() {
  return <section className="py-20 px-4 bg-brand-cream" data-id="element-87" data-mp="2a8n2r48ftww8">
      <div className="max-w-5xl mx-auto" data-id="element-88" data-mp="2f6ye5jedsfgk">
        <h2 className="text-3xl md:text-4xl font-black text-brand-text text-center mb-16" data-id="element-89" data-mp="2f66gm31847nn">
          ¿Qué contiene el Kit Yoga Lista?
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-90" data-mp="2nz07kxq18vhc">
          {kitContents.map((item, i) => {
          const Icon = icons[item.icon];
          return <article key={item.title} className={`bg-brand-panel rounded-3xl p-8 text-center border border-brand-creamDark/60 shadow-sm flex flex-col items-center ${i === kitContents.length - 1 ? 'md:col-span-2 md:w-1/2 md:mx-auto' : ''}`} data-id="element-91" data-mp="2sznylje9hcbk" data-mpi={i}>
                <Icon className="w-8 h-8 text-brand-green mb-4" aria-hidden="true" data-id="element-92" data-mp="vky8trb9h2cm" />
                <h3 className="text-xl font-serif font-bold text-brand-text mb-2" data-id="element-93" data-mp="mluo6iwg4ew0">
                  {item.title}
                </h3>
                <p className="text-brand-gray text-sm mt-auto" data-id="element-94" data-mp="1jcdffwa2m5to">{item.desc}</p>
              </article>;
        })}
        </div>
      </div>
    </section>;
}